import LocationCitySearchPagingResultModelBase from '../_generated/modelBases/location-city-search-paging-result-model-base';

export default class LocationCitySearchPagingResultModel extends LocationCitySearchPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
